
import { CFArrayFount, CFDateTimeFormatEdit, CFDateEdit, CFStingMasterEdit } from "./CommonFunction";
import { SORTINFO_STORAGE } from "./CodeDefinition";

const ExcelJS = require('exceljs');
export const CreateExcel = async(title,config,dataRow,codeDefinitionValue,master,date) =>{
	const today = date ? new Date(date): new Date();
	const year = today.getFullYear();//年を取得
	const month = ('00' + (today.getMonth()+1)).slice(-2) //月を取得
	const day = ('00' + (today.getDate())).slice(-2); //日を取得
	const fileName = `${title}${year}${month}${day}.xlsx`;

	//数字 → アルファベットに変換する関数
	function numberToAlphabet(number) {
		let result = '';
		const base = 'A'.charCodeAt(0); // 'A' の文字コード

		while (number > 0) {
			const remainder = (number - 1) % 26; // 0 から 25 の範囲になるように調整
			result = String.fromCharCode(base + remainder) + result; // アルファベットを文字列に追加
			number = Math.floor((number - 1) / 26); // 次の桁に進む
		}

		return result;
	};

	// Workbookの作成
	const workbook = new ExcelJS.Workbook();
	// Workbookに入れたファイルのシートを取得
	workbook.addWorksheet(`${year}-${month}-${day}`);
	const worksheet = workbook.getWorksheet(`${year}-${month}-${day}`);
	const head = [];
	
	config.forEach((item)=>{
		head.push({
			header:item.name,
			key:item.id,
		});

	});
	worksheet.columns = head;

	/* ====== sessionStorageからの情報を定義 ====== */
	const sortInfoStorage = sessionStorage.getItem(SORTINFO_STORAGE);//sessionStorageからコードマスタを取得
	var sortInfoValue = JSON.parse(sortInfoStorage) ?? { order: '', orderBy: ''};//JSON 文字列を取得し、JavaScriptオブジェクトに変換

	// 出力する項目のソート順を指定
	if (sortInfoValue.order === 'asc') {
		//昇順の場合
		dataRow.sort((a, b) => {
			if(a[sortInfoValue.orderBy] > b[sortInfoValue.orderBy]) return 1;
    		if(a[sortInfoValue.orderBy] < b[sortInfoValue.orderBy]) return -1;
			return 0;
		})
	} else if (sortInfoValue.order === 'desc') {
		//降順の場合
		dataRow.sort((a, b) => {
			if(a[sortInfoValue.orderBy] > b[sortInfoValue.orderBy]) return -1;
    		if(a[sortInfoValue.orderBy] < b[sortInfoValue.orderBy]) return 1;
			return 0;
		})
	}

	const dataEdit = [];
	const colorColumnList = [];//セル色付け用配列
	const colorRowList = [];//row色付け用配列
	dataRow.forEach((item,itemIndex)=>{
		const row = {};
		config.forEach((head,headIndex)=>{
			switch(head.type){
				case 'normal':
					row[head.id] = item[head.id];
				break;
				case 'edit':
					if(head.masterType === 'master'){
						const codeDf = CFArrayFount(master,'code',head.master);
						row[head.id] =  CFStingMasterEdit(codeDf, item[head.id])

                    }else if(head.masterType === 'codeMaster'){
						const codeDf = CFArrayFount(codeDefinitionValue,'code',head.master);
						row[head.id] =  CFStingMasterEdit(codeDf, item[head.id])
                    };
				break;
				case 'date':
					row[head.id] = CFDateEdit(item[head.id]);
				break;
				case 'time':
					row[head.id] = CFDateTimeFormatEdit(item[head.id]);
				break;
				case 'combo':
					let result;
					head.list.forEach((branch)=>{
						result = result ? result + ' '+ item[branch] : item[branch];
					});
					row[head.id] = result;
				break;
				case 'multiple':
					row[head.id] = item[head.id1] + (item[head.id2] ? ' ' + item[head.id2] : '') + (item[head.id3] ? ' ' + item[head.id3] : '')  + (item[head.id4] ?' ' +  item[head.id4] : '');
				break;
				default:
					row[head.id] = item[head.id];
				break;
			};
			//セル色付け処理
			if(typeof head.otherItemCheck === 'object'){
				if(head.type === 'multiple'){//multipleの場合はid1を対象とする
					//先月末からの変更項目に含まれる場合
					if(item.upItemName.includes(head.id1)){
						//セル色付けオブジェクトを設定
						colorColumnList.push({
							type: 'pattern',
							pattern: 'solid',
							fgColor: { argb: head.otherItemCheck.color.replace('#','')}, // カラーコードから#を削除
							fill: `${numberToAlphabet(headIndex + 1)}${itemIndex + 2}`//色付けを行うセルを計算

						});
					};

				}else{
					//先月末からの変更項目に含まれる場合
					if(item.upItemName.includes(head.id)){
						//セル色付けオブジェクトを設定
						colorColumnList.push({
							type: 'pattern',
							pattern: 'solid',
							fgColor: { argb: head.otherItemCheck.color.replace('#','')}, // カラーコードから#を削除
							fill: `${numberToAlphabet(headIndex + 1)}${itemIndex + 2}`//色付けを行うセルを計算

						});
					};
				}


			};
			// 値がチェック対象の値と一致するかのチェック
			if(typeof head.valueCheck === 'object'){
				if(row[head.id] === head.valueCheck.value){
					//セル色付けオブジェクトを設定
					colorColumnList.push({
						type: 'pattern',
						pattern: 'solid',
						fgColor: { argb: head.valueCheck.color.replace('#','')}, // カラーコードから#を削除
						fill: `${numberToAlphabet(headIndex + 1)}${itemIndex + 2}`//色付けを行うセルを計算
					});
				};
			};
			// rowに色付けを行うindexを配列に格納
			if(item.acptaRquValiFlag === 'false' || item.acptaRquValiFlag === false){ //受入申請が無効(受入中止)
				//配列に格納
				colorRowList.push({
					index:itemIndex + 2,//ヘッダーを含むため、+2する
					type: 'pattern',
					pattern: 'solid',
					fgColor:{ argb: 'F0F0F0' }
				});
			}else if(item.asiFlag === 'false'|| item.asiFlag === false){ //受入申請が無効(受入中止)従業員一覧
				//配列に格納
				colorRowList.push({
					index:itemIndex + 2,//ヘッダーを含むため、+2する
					type: 'pattern',
					pattern: 'solid',
					fgColor:{ argb: 'F0F0F0' }
				});
			}else if(item.moveInFlag === 'true'|| item.moveInFlag === true){ //当月に転入した 従業員一覧
				//配列に格納
				colorRowList.push({
					index:itemIndex + 2,//ヘッダーを含むため、+2する
					type: 'pattern',
					pattern: 'solid',
					fgColor:{ argb: 'FFFF00' }
				});
			}
		});
			dataEdit.push(row);
	});
	worksheet.addRows(dataEdit);
	//行全体に色付け
	colorRowList.forEach((row) =>{
		let getRow = worksheet.getRow(row.index);
		getRow.eachCell({ includeEmpty: true }, cell => {
			cell.fill = {
				type: row.type,
				pattern: row.pattern,
				fgColor: row.fgColor
			};
		});

	});
	//セル色付け反映
	colorColumnList.forEach((column) =>{
		worksheet.getCell(column.fill).fill = {
			type: column.type,
			pattern: column.pattern,
			fgColor: column.fgColor
		};

	});

	// UInt8Arrayを生成
	const uint8Array = await workbook.xlsx.writeBuffer();
	// Blobを生成
	const blob = new Blob([uint8Array], {type: 'application/octet-binary'});
	// DL用URLを生成し、aタグからダウンロードを実行
	const url = window.URL.createObjectURL(blob);
	// aタグを生成
	const a = document.createElement('a');
	// aタグのURLを設定
	a.href = url;
	// aタグにdownload属性を付け、URLがダウンロード対象になるようにします
	a.download = fileName
	// aタグをクリックさせます
	a.click();
	// ダウンロード後は不要なのでaタグを除去
	a.remove();  
};
